import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { loadMoreProducts } from '../../../actions';
import useIsInViewport from '../../../hooks/useIsInViewport';

const LoadMore = ({
    activeSection,
    activeHandle,
    afterCursor,
    currentProducts,
    currentFilters,
    dispatch,
    hasNextPage,
    swiperState,
    loading,
    scrollContainer,
    skintone,
}) => {
    const [slideTo, setSlideTo] = useState(0);
    const [fullyScrolled, setFullyScrolled] = useState(false);
    const buttonRef = useRef(null);
    const isInViewport = useIsInViewport(buttonRef);

    useEffect(() => {
        if (!scrollContainer.current) {
            return;
        }

        const scrollContainerHeight = scrollContainer.current.offsetHeight;
        let maxScrollHeight = scrollContainer.current.scrollHeight;
        let scrollPos = scrollContainer.current.scrollTop;

        const checkScrollPos = () => {
            maxScrollHeight = scrollContainer.current.scrollHeight;
            scrollPos = scrollContainer.current.scrollTop;

            if (scrollPos + scrollContainerHeight === maxScrollHeight) {
                setFullyScrolled(true);
            }
        };

        scrollContainer.current?.addEventListener('scroll', checkScrollPos);
        return () => scrollContainer.current?.removeEventListener('scroll', checkScrollPos);
    }, [scrollContainer]);

    useEffect(() => {
        const buttonDisplay = window.getComputedStyle(buttonRef.current, null).display;
        if (isInViewport || (fullyScrolled && buttonDisplay !== 'none')) {
            const active = swiperState?.activeIndex;
            setSlideTo(active);
            setFullyScrolled(false);

            dispatch(
                loadMoreProducts(
                    activeSection,
                    activeHandle,
                    afterCursor,
                    currentProducts,
                    currentFilters,
                    skintone,
                )
            );
        }
    }, [isInViewport, fullyScrolled]);

    useEffect(() => {
        if (!loading) {
            swiperState?.slideTo(slideTo, 0);
        }
    }, [loading]);

    if (!hasNextPage) {
        return (
            <div className="load-more">
                <small>End of products</small>
                <button ref={buttonRef} style={{ display: 'none' }} />
            </div>
        );
    }

    return (
        <button
            ref={buttonRef}
            className="button load-more"
            style={{ opacity: 0 }}
            onClick={() => {
                dispatch(
                    loadMoreProducts(
                        activeSection,
                        activeHandle,
                        afterCursor,
                        currentProducts,
                        currentFilters,
                        skintone,
                    )
                );
            }}
        >
            Load more
        </button>
    );
};

const mapStateToProps = state => {
    return {
        activeSection: state.navigation.selected,
        activeHandle: state.browser.selectedCategory.handle,
        afterCursor: state.paginationInfo.afterCursor,
        hasNextPage: state.paginationInfo.hasNextPage,
        currentProducts: state.browser.products,
        currentFilters: state.currentFilters,
        loading: state.loading,
        skintone: state.builds[state.currentBuildIndex].skintone,
    };
};

export default connect(mapStateToProps)(LoadMore);
